<template>
  <user-delegation-permissions-data-form></user-delegation-permissions-data-form>
</template>

<script>
import UserDelegationPermissionsDataForm from "../../../components/Settings/Users/UserDelegationPermissionsDataForm";
export default {
  name: "AdminUsersEditRolesAndPermissionView",
  components: { UserDelegationPermissionsDataForm }
};
</script>

<style scoped></style>
